/**
 * Internal function to inject listFilter results back to result object when they are removed in next() function
 * Should not be used outside of library itself
 *
 * @category Modifier
 * @param prevQuery
 * @returns
 */
export function injectFilterResult(prevQuery) {
    return {
        klevuModifierId: "injectFilteResult",
        onResult: (response) => {
            var _a, _b;
            const copy = Object.assign({}, response);
            const found = (_b = (_a = copy.apiResponse) === null || _a === void 0 ? void 0 : _a.queryResults) === null || _b === void 0 ? void 0 : _b.find((q) => q.id === prevQuery.id);
            if (found) {
                found.filters = prevQuery.filters;
            }
            return copy;
        },
    };
}
